import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StudentResultRoutingModule } from './student-result-routing.module';
import { StandardListComponent } from './standard-list/standard-list.component';
import { StandardDetailsComponent } from './standard-details/standard-details.component';
import { AddResultComponent } from './add-result/add-result.component';

@NgModule({
  declarations: [
    StandardListComponent,
    StandardDetailsComponent,
    AddResultComponent
  ],
  imports: [
    CommonModule,
    StudentResultRoutingModule
  ]
})
export class StudentResultModule { }
